import { IPagination } from 'app/types/common';

export interface IBankAccountsState {
  readonly bankAccountsById?: any;
  readonly bankAccountIds?: string[];
  readonly saved?: boolean;
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddBankAccount?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly currentBankAccountId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IBankAccountsSelector extends IBankAccountsState {
  readonly currentBankAccount?: any;
  readonly getBankAccountsFilteredByTagInSelectFormat?: any;
  readonly bankAccountsByIdInSelectFormat?: any;
}

export enum BankAccountsActionTypes {
  GET_ALL_BANK_ACCOUNTS_REQUESTED = 'redux-app/bank-accounts/GET_ALL_BANK_ACCOUNTS_REQUESTED',
  GET_ALL_BANK_ACCOUNTS_PENDING = 'redux-app/bank-accounts/GET_ALL_BANK_ACCOUNTS_PENDING',
  GET_ALL_BANK_ACCOUNTS_SUCCESS = 'redux-app/bank-accounts/GET_ALL_BANK_ACCOUNTS_SUCCESS',
  GET_ALL_BANK_ACCOUNTS_FAIL = 'redux-app/bank-accounts/GET_ALL_BANK_ACCOUNTS_FAIL',
  GET_BANK_ACCOUNT_REQUESTED = 'redux-app/bank-accounts/GET_BANK_ACCOUNT_REQUESTED',
  GET_BANK_ACCOUNT_PENDING = 'redux-app/bank-accounts/GET_BANK_ACCOUNT_PENDING',
  GET_BANK_ACCOUNT_SUCCESS = 'redux-app/bank-accounts/GET_BANK_ACCOUNT_SUCCESS',
  GET_BANK_ACCOUNT_FAIL = 'redux-app/bank-accounts/GET_BANK_ACCOUNT_FAIL',
  UPDATE_BANK_ACCOUNT_REQUESTED = 'redux-app/bank-accounts/UPDATE_BANK_ACCOUNT_REQUESTED',
  UPDATE_BANK_ACCOUNT_PENDING = 'redux-app/bank-accounts/UPDATE_BANK_ACCOUNT_PENDING',
  UPDATE_BANK_ACCOUNT_SUCCESS = 'redux-app/bank-accounts/UPDATE_BANK_ACCOUNT_SUCCESS',
  UPDATE_BANK_ACCOUNT_FAIL = 'redux-app/bank-accounts/UPDATE_BANK_ACCOUNT_FAIL',
  CREATE_BANK_ACCOUNT_REQUESTED = 'redux-app/bank-accounts/CREATE_BANK_ACCOUNT_REQUESTED',
  CREATE_BANK_ACCOUNT_PENDING = 'redux-app/bank-accounts/CREATE_BANK_ACCOUNT_PENDING',
  CREATE_BANK_ACCOUNT_SUCCESS = 'redux-app/bank-accounts/CREATE_BANK_ACCOUNT_SUCCESS',
  CREATE_BANK_ACCOUNT_FAIL = 'redux-app/bank-accounts/CREATE_BANK_ACCOUNT_FAIL',
  DELETE_BANK_ACCOUNT_REQUESTED = 'redux-app/bank-accounts/DELETE_BANK_ACCOUNT_REQUESTED',
  DELETE_BANK_ACCOUNT_PENDING = 'redux-app/bank-accounts/DELETE_BANK_ACCOUNT_PENDING',
  DELETE_BANK_ACCOUNT_SUCCESS = 'redux-app/bank-accounts/DELETE_BANK_ACCOUNT_SUCCESS',
  DELETE_BANK_ACCOUNT_FAIL = 'redux-app/bank-accounts/DELETE_BANK_ACCOUNT_FAIL',
  SELECT_BANK_ACCOUNT_REQUESTED = 'redux-app/bank-accounts/SELECT_BANK_ACCOUNT_REQUESTED'
}

export default null;
